'use strict';

Odigeo.defineWidget('progress_bar', Odigeo.Widget.extend({
    viewClass: require('./progress_bar.view'),
    setPaymentState(step) {
        this.view.setPaymentState(step);
    },
}));


